import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
  sub,
} from "date-fns";

import { formatDateForApi } from "@/utils";
import { msg } from "@lingui/core/macro";

const TODAY = new Date();

// Effectively unbounded: there is no mention data this old.
const ALL_RESULTS_START_DATE = new Date(2000, 0, 1);

// Use this anywhere outside the date picker that wants to show all results, so
// that the picker still highlights the "Alla träffar" preset (it matches on the
// formatted dates).
export const ALL_RESULTS_DATE_FILTERS = {
  start_date: formatDateForApi(ALL_RESULTS_START_DATE),
  end_date: formatDateForApi(TODAY),
};

export const MENTION_VIEW_DATE_RANGES = [
  {
    startDate: ALL_RESULTS_START_DATE,
    endDate: TODAY,
    label: msg`Alla träffar`,
    identifier: "all_results",
  },
  {
    startDate: sub(TODAY, { hours: 24 }),
    endDate: TODAY,
    label: msg`Senaste dygnet`,
    identifier: "last_24_hours",
  },
  {
    startDate: sub(TODAY, { days: 7 }),
    endDate: TODAY,
    label: msg`Senaste 7 dagarna`,
    identifier: "last_7_days",
  },
  {
    startDate: sub(TODAY, { days: 30 }),
    endDate: TODAY,
    label: msg`Senaste 30 dagarna`,
    identifier: "last_30_days",
  },
  {
    startDate: sub(TODAY, { months: 3 }),
    endDate: TODAY,
    default: true,
    label: msg`Senaste 3 månader`,
    identifier: "last_3_months",
  },
  {
    startDate: startOfMonth(TODAY),
    endDate: TODAY,
    label: msg`Denna månad`,
    identifier: "this_month",
  },
  {
    startDate: startOfMonth(sub(TODAY, { months: 1 })),
    endDate: endOfMonth(sub(TODAY, { months: 1 })),
    label: msg`Föregående månad`,
    identifier: "previous_month",
  },
  {
    startDate: startOfYear(TODAY),
    endDate: TODAY,
    label: msg`Detta året`,
    identifier: "this_year",
  },
  {
    startDate: startOfYear(sub(TODAY, { years: 1 })),
    endDate: endOfYear(sub(TODAY, { years: 1 })),
    label: msg`Föregående år`,
    identifier: "previous_year",
  },
];
